import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/variables.css'
import './styles/utilities.css'
import './styles/animations.css'
import './styles/element-override.css'
// 通过环境变量控制是否启用 Mock
// VUE_APP_USE_MOCK=true（默认）：启用 mock，所有 API 请求走前端本地模拟
// VUE_APP_USE_MOCK=false：关闭 mock，所有 API 请求走真实后端
if (process.env.VUE_APP_USE_MOCK !== 'false') {
  require('./mock')
  console.log('[MAIN] mock module loaded, version=2')
} else {
  console.log('[MAIN] mock module disabled, using real backend API')
}
import { hasPermission } from './utils/permission'
import * as api from './api'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局挂载权限检查方法，供模板直接使用
Vue.prototype.$hasPermission = function(permission) {
  return hasPermission(this.$store, permission)
}

// 全局挂载 API 模块，方便调试和组件内快速调用
Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
